Vue.asyncComponent('ak-popover-menu-divider', {
}, 'layout/partials/ak-popover-menu-divider.html');